// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1Qkhv","label":"CategoryService_label__3054x","location":"CategoryService_location__28cah"};